import React from 'react'
import { post } from 'axios';
import { message } from 'antd';

class SimpleReactFileUpload extends React.Component {

  constructor(props) {
    super(props);
    this.state ={
      file:null
    }
    this.onFormSubmit = this.onFormSubmit.bind(this)
    this.onChange = this.onChange.bind(this)
    this.fileUpload = this.fileUpload.bind(this)
  }

  onFormSubmit(e){
    e.preventDefault() // Stop form submit
    if(!this.state.file){
      message.error("Debe seleccionar un archivo")
    }
    else{
      this.fileUpload(this.state.file).then((response)=>{
        if(response.data.status == 'success'){
          message.success('Los datos han sido actualizados en la base de datos')
        }
        else{
          message.error(response.data.status);
        }
      })
    }
  }

  onChange(e) {
    this.setState({file:e.target.files[0]})
  }

  fileUpload(file){
    const url = 'https://a3l.com.ar/Cotizador/Backend/importExcel'; //'http://example.com/file-upload';
    const formData = new FormData();
    formData.append('excel',file)
    const config = {
        headers: {
            'content-type': 'multipart/form-data'
        }
    }
    return  post(url, formData,config)
  }

  render() {
    return (
      <form onSubmit={this.onFormSubmit} >
        <h1>Actualizar Parametros</h1>
        <input type="file" onChange={this.onChange} name="file"/>
        <button type="submit">Confirmar</button>
      </form>
   )
  }
}



export default SimpleReactFileUpload